export const ButtonSpinner = ({ className = "", text = "Loading..." }) => {
  return (
    <button
      className={`btn btn-dark ${className} btn-sm`}
      type="button"
      disabled
    >
      <span
        className="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>{" "}
      {text}
    </button>
  );
};
